/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CertLicenseIcon16Light } from './CertLicenseIcon16Light';
import { CertLicenseIcon16Regular } from './CertLicenseIcon16Regular';
import { CertLicenseIcon16Solid } from './CertLicenseIcon16Solid';
import { CertLicenseIcon20Light } from './CertLicenseIcon20Light';
import { CertLicenseIcon20Regular } from './CertLicenseIcon20Regular';
import { CertLicenseIcon20Solid } from './CertLicenseIcon20Solid';
import { CertLicenseIcon24Regular } from './CertLicenseIcon24Regular';
import { CertLicenseIcon24Solid } from './CertLicenseIcon24Solid';
import { CertLicenseIcon32Regular } from './CertLicenseIcon32Regular';
import { CertLicenseIcon64Regular } from './CertLicenseIcon64Regular';
var sizes = {
    16: {
        light: CertLicenseIcon16Light,
        regular: CertLicenseIcon16Regular,
        solid: CertLicenseIcon16Solid,
    },
    20: {
        light: CertLicenseIcon20Light,
        regular: CertLicenseIcon20Regular,
        solid: CertLicenseIcon20Solid,
    },
    24: {
        regular: CertLicenseIcon24Regular,
        solid: CertLicenseIcon24Solid,
    },
    32: {
        regular: CertLicenseIcon32Regular,
    },
    64: {
        regular: CertLicenseIcon64Regular,
    },
};
export var CertLicenseIcon = forwardRef('CertLicenseIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
